import { useState, useEffect } from 'react'
import { getRepeatCount } from '../helpers'
import { useSequencedFormData } from '../SequencedFormDataProvider'
import { setFormData } from '../SequencedFormDataProvider/actions'

export default withRepeater = (Base, accessorProps = {}) ->
  {
    getter = 'value',
    setter = 'onChange',
    selector = ({ target: { value } }) -> value,
  } = accessorProps

  (props) ->
    { form, config = {}, formItem } = props
    [repeater, setRepeater] = useState(undefined)

    useEffect(->
      ( -> setRepeater(await getRepeatCount(form, config.repeatOn)) )()
      undefined
    , [])

    [{ formData }, dispatch] = useSequencedFormData()

    return <i>N/A</i> if !repeater? or (repeater is 0)

    accessors = (
      if repeater is 1
        {
          getter: ->
            if _.isArray(form.getFieldValue(formItem)) and config.mode isnt 'multiple'
              form.getFieldValue(formItem)[0]
            else
              form.getFieldValue(formItem)
          setter: (value) ->
            form.setFieldsValue({ [formItem]: value })
        }
      else
        {
          getter: (i) ->
            form.getFieldValue(formItem)?[i]
          setter: (value, i) ->
            valObj = _.get(formData, formItem) or {}
            valObj[i] = value
            form.setFieldsValue({ [formItem]: valObj })
        }
    )

    [1..repeater].map((key, i) ->
      inputProps = {
        props...
        [getter]: accessors.getter(i)
        [setter]: (el) -> accessors.setter(selector(el), i)
      }
      <div style={{ marginBottom: 5 }} key="#{ formItem }-repeater-#{ i }">
        <Base { inputProps... } />
      </div>
    )
